module.exports = __webpack_public_path__ + "static/media/Elabs logo black.e7a8e7af.png";